import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import People from './components/People'
import SpeakerForm from '../speakers/SpeakerForm'
import AttendeeForm from '../attendees/AttendeeForm'

const PeopleRoutes = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route exact path={path}>
        <People />
      </Route>
      {/* Speaker routes */}
      <Route path={`${path}/speakers/new`}>
        <SpeakerForm displayContext="page" />
      </Route>
      <Route path={`${path}/speakers/edit/:speakerId`}>
        <SpeakerForm displayContext="page" />
      </Route>
      {/* Attendee routes */}
      <Route path={`${path}/attendees/edit/:attendeeId`}>
        <AttendeeForm displayContext="page" />
      </Route>
    </Switch>
  )
}

export default PeopleRoutes
